import { connectedStore } from '../../store';
import selectors from '../selectors';

const getCurrentLocale = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getCurrentLocale(state);
};

export default getCurrentLocale;
